/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CacheMetric = {
    properties: {
        startDate: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        endDate: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        hits: {
            type: 'number',
            isRequired: true,
        },
        misses: {
            type: 'number',
            isRequired: true,
        },
        total: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
